/* eslint-disable no-console */
import moment from 'moment'
import { ApiLmLg030 } from '@/endpoints/ApiLmLg030'

export type ApiLogStatusId = 'Info' | 'Warning' | 'Error'
export type ApiLogActionId = 'ACT-TA-00001' | 'ACT-TA-00002' | 'ACT-TA-00003' | 'ACT-TA-00004' | 'ACT-TA-00005' | 'ACT-TA-00006' | 'ACT-TA-00007' | 'ACT-TA-00008' | 'ACT-TA-00009' | 'ACT-TA-00010' | 'ACT-TA-00011' | 'ACT-TA-00012' | 'ACT-TA-00013' | 'ACT-TA-00014'
export type ApiLogAction = { actionId: ApiLogActionId, message: string, statusId: ApiLogStatusId}
export interface LoggerInterface {
    trace(...arg: any[]): void
    debug(...arg: any[]): void
    info(...arg: any[]): void
    warning(...arg: any[]): void
    error(...arg: any[]): void
    logActionId(actionId: ApiLogActionId, screenId: string): void
}


const logData = require('@/assets/json/action-logs.json') as ApiLogAction[]
export class Logger implements LoggerInterface {

    private logString(...arg: any[]): string[] {
        return [moment().format(), ':', ...arg]
    }

    public trace(...arg: any[]): void {
        // eslint-disable-next-line no-console
        console.log('TRACE', ...this.logString(...arg))
    }

    public debug(...arg: any[]): void {
        // eslint-disable-next-line no-console
        console.log('DEBUG', ...this.logString(...arg))
    }

    public info(...arg: any[]): void {
        // eslint-disable-next-line no-console
        console.info('INFO', ...this.logString(...arg))
    }

    public warning(...arg: any[]): void {
        // eslint-disable-next-line no-console
        console.warn('WARN', ...this.logString(...arg))
    }

    public error(...arg: any[]): void {
        // eslint-disable-next-line no-console
        console.error('ERROR', ...this.logString(...arg))
    }

    public logActionId(actionId: ApiLogActionId, screenId: string) {
        const targetLog = logData.find(data => {
            return data.actionId === actionId
        })
        if (!targetLog) {
            return
        }
        const api = new ApiLmLg030.Api()
        api.post<any | null>(
            {
                body: {
                    screenId,
                    actionId,
                    statusId: targetLog.statusId,
                    message: targetLog.message,
                    learningTime: null
                },
            },
            // 成功しても失敗しても何もしない
            () => {},
            () => {}
        )
    }
}

// eslint-disable-next-line import/no-mutable-exports
let logger: LoggerInterface
export function initializeLogger(loggerInstance: LoggerInterface) {
    logger = loggerInstance
}

export { logger }